import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import getPermissions from "@/helpers/getPermissions";
import Toast from "@/partials/Toast";
import vSelect from "vue-select";
import Pagination from "laravel-vue-pagination";
import Datepicker from "vue-flatpickr-component";

//signature pad
import VueSignaturePad from "vue-signature-pad";

// CSS Modules
import "animate.css";
import "leaflet/dist/leaflet.css";
import "@/assets/scss/_index.scss";

const app = createApp(App);

// Register global components
app.component("Toast", Toast);
app.component("Pagination", Pagination);
app.component("VSelect", vSelect);
app.component("Datepicker", Datepicker);

// Use plugins
app.use(store);
app.use(i18n);
app.use(router);
app.use(VueSignaturePad);

// Global properties
app.config.globalProperties.$checkRolePermission = (permission) =>
  permission === "default"
    ? true
    : getPermissions().some((p) => p.title === permission);

app.mount("#app");
